// Adapted from From https://stackoverflow.com/questions/25553910/one-liner-to-take-some-properties-from-object-in-es-6
export const pick = (o: any, keys: string[]) => {
	return Object.assign({}, ...keys.map((k) => ({[k]: o[k]})));
};

export function asyncSleep(seconds: number): Promise<void> {
	const ms = seconds * 1000;

	return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getDateComponent(date: string, component: string): string {
	const components = date.split('-');
	if (components.length === 3) {
		switch (component) {
			case 'year':
				return components[0];
			case 'month':
				return components[1];
			case 'day':
				return components[2];
		}
	}

	return '';
}

export function dateFromComponents(
	year: string,
	month: string,
	day: string
): string {
	return [year, month, day].join('-');
}
